import {NgModule} from "@angular/core";
import {OppgaveKommentarerKomponentAvhengigheter} from "./komponenter/oppgave-kommentarer/oppgave-kommentarer";
import {OppgaveRedigerDialogKomponentAvhengigheter} from "web-ng2/moduler/oppgave/modale/oppgave-rediger-dialog/oppgave-rediger-dialog";
import {OppgaveOpprettDialogKomponentAvhengigheter} from "web-ng2/moduler/oppgave/modale/oppgave-opprett-dialog/oppgave-opprett-dialog";
import {OppgaveSkjemaKomponentAvhengigheter} from "web-ng2/moduler/oppgave/komponenter/oppgave-skjema/oppgave-skjema";
import {OppgaveListevisningKompaktKomponentAvhengigheter} from "web-ng2/moduler/oppgave/komponenter/oppgave-listevisning-kompakt/oppgave-listevisning-kompakt";
import {OppgavelisteKompaktKomponentAvhengigheter} from "web-ng2/moduler/oppgave/komponenter/oppgaveliste-kompakt/oppgaveliste-kompakt";

@NgModule({
    providers: [
        OppgaveKommentarerKomponentAvhengigheter,
        OppgaveSkjemaKomponentAvhengigheter,
        OppgaveRedigerDialogKomponentAvhengigheter,
        OppgaveOpprettDialogKomponentAvhengigheter,
        OppgaveListevisningKompaktKomponentAvhengigheter,
        OppgavelisteKompaktKomponentAvhengigheter
    ]
})
export class OppgaveModul{

}
